define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/ServiceTypeModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, ServiceTypeModel, UserContext) {
    "use strict";
    var ServiceTypes = /** @class */ (function () {
        function ServiceTypes() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,ServiceType.Edit,ServiceType.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,ServiceType.Delete"));
            this.editModel = ko.observable(new ServiceTypeModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        ServiceTypes.prototype.init = function () {
            var self = this;
            $("#page-title").text("Service Types");
            tools.ajaxGet({
                url: "/ServiceType/GetServiceTypesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initServiceTypes(self.lookupLists.GridStructures.ServiceTypeStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    //self.initMenu();
                    //self.initLogs();
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        ServiceTypes.prototype.initServiceTypes = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "serviceTypeTable";
            self.ServiceTypeTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    toolbar: kendo.template($("#service-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ServiceType/GetServiceTypes",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "ServiceType",
                    title: "Service Types",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.ServiceTypeTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.ServiceTypeTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editServiceType(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteServiceTypeConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        ServiceTypes.prototype.editServiceType = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Service Type" : "Add Service Type";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    if (!self.editModel().ProviderId()) {
                        tools.error("Provider is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveServiceType(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/ServiceType/GetServiceTypeById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ServiceTypeModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ServiceTypeModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'service-type-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        ServiceTypes.prototype.saveServiceType = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ServiceType/SaveServiceType",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.ServiceTypeTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ServiceTypes.prototype.deleteServiceTypeConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Service Type",
                text: 'Are you sure you want to delete service type "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteServiceType(id);
            });
        };
        ServiceTypes.prototype.deleteServiceType = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ServiceType/DeleteServiceTypeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Service type deleted successfully");
                    self.ServiceTypeTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ServiceTypes.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        ServiceTypes.prototype.exportTo = function () {
            var self = this;
            self.ServiceTypeTable.exportTo();
        };
        ServiceTypes.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("ServiceType");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return ServiceTypes;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ServiceType/Index")) {
            log.log("Initialize Service Type");
            $(function () {
                (new ServiceTypes()).init();
            });
        }
    }, 0);
    return ServiceTypes;
});
//# sourceMappingURL=serviceTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/serviceTypes.js
// module id = 222
// module chunks = 2